import httpService from "../../Service/httpService";

const controller = "Filtros";


export const getAsignacion = async (id, idPac) => {
	const res = await httpService.get(
		`/${controller}/getAsignacion/${id}/${idPac}`
	);
	return res.data;
};

export const getCatFiltros = async (id, opc) => {
	const res = await httpService.get(
		`/${controller}/getCatFiltros/${id}/${opc}`
	);
	return res.data;
};

export const getStockFiltro = async (id, idFiltro) => {
	const res = await httpService.get(
		`/${controller}/getStockFiltro/${id}/${idFiltro}`
	);
	return res.data;
};

export const getClasificaFiltros = async (id) => {
	const res = await httpService.get(
		`/${controller}/getClasificaFiltros/${id}`
	);
	return res.data;
};

export const getListaFiltros = async (id) => {
	const res = await httpService.get(
		`/${controller}/getListaFiltros/${id}`
	);
	return res.data;
};

export const getFiltrosXInventario = async (id) => {
	const res = await httpService.get(
		`/${controller}/getFiltrosXInventario/${id}`
	);
	return res.data;
};

export const getListaPacientesFiltro = async (id) => {
	const res = await httpService.get(
		`/${controller}/getListaPacientesFiltro/${id}`
	);
	return res.data;
};


export const saveAsignaModalidadUso = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveAsignaModalidad`, {
		...data,
	});
	return res;
};

export const saveEntradaFiltro = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveEntradaFiltro`, {
		...data,
	});
	return res;
};

export const saveFiltro = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveFiltro`, {
		...data,
	});
	return res;
};

export const saveAsignaFiltro = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveAsignaFiltro`, {
		...data,
	});
	return res;
};

